var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSgx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1555 456",
    width: 1555,
    height: 456,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7b0d6cda8853ac989d6e8670592a46c6-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #bdd831 } \n\t\t.s2 { fill: #0b236b } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1099.3 0.4h455v455.2h-455z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m1112.5 13.6h428.6v85.7h-428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m1112.5 99.3h428.6v85.8h-428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m1112.5 185.1h428.6v85.7h-428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m1112.5 270.8h428.6v85.8h-428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m1112.5 356.6h428.6v85.7h-428.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m311.3 306.1c0 42-15.5 75.6-46.7 101-31 25.4-72.3 38.1-123.8 38.1-50.2 0-97.2-12.6-140.7-37.4l31-64.8q63.4 33.1 113.3 33.1c48.3 0 72.4-18.7 72.4-56.3 0-25.9-18-43.6-54-53.5l-45.7-12.5c-39.5-10.8-66.8-28.2-81.3-52.3-11.6-19-17.3-40.1-17.3-63 0-37.7 13.7-68.5 41.2-92.1 27.6-23.9 63.1-35.7 106.8-35.7 53.3 0 99.2 13.9 137.7 41.5l-39.2 59.5c-34.9-21-67-31.5-96.2-31.5-17.1 0-30.9 4.5-41.7 13.5-10.7 8.9-16 20.3-16 34.1 0 10.7 3.4 19.1 10.1 25.3 6.8 6.1 18.6 11.6 35.7 16.3l49.9 13.7c69.7 19 104.5 60 104.5 123z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m663.7 406c-42.4 25.1-89 37.7-139.8 37.7-62.3 0-110.1-21.6-143.6-64.4q-44.8-57.5-44.8-147.3c0-88.4 29.3-152.2 87.8-191.5 29.5-19.8 63.6-29.8 102.4-29.8 52 0 96.7 16.3 133.9 48.7l-44.9 52.6c-26.6-21.7-56-32.7-87.8-32.7-25.4 0-45.7 7.2-60.6 21.2-23.7 23.1-35.7 68.4-35.7 135.8 0 59.3 10.5 99.4 31.4 120 16.2 15.7 38.3 23.7 66.1 23.7 18.7 0 34.6-3.5 47.9-10.3v-95.8h-64.2l-11-69.2h162.9v201.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m1033.8 436.2h-100.2l-74.3-145.5-73.6 145.5h-103.4l129.4-221.1-111.6-191.9h101.6l55.8 111.2 56.5-111.2h99.1l-107.4 186.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgx);
export default __webpack_public_path__ + "static/media/SGX.c11c553d50acca00e30dec9d4068ddc2.svg";
export { ForwardRef as ReactComponent };